'use strict';

module.exports = '2.26.1';
